module.exports = __webpack_public_path__ + "static/transposh5-886e4c8653a4f644c741a55e44bb12a2.jpg";